import TimeTaxSupportSystemClient from '../../../../../system';
import { User } from '../../../../../system/User';
import MessageCourier from '../../../../../lib/MessageCourier';
import { DateTime } from 'luxon';
import StatusFilms from '../../../carga/StatusFilms';
import { LevelsTable } from './LevelsTable';
import { LiquidacionInsumo } from '../../../../../system/settlement/aje/liquidacion-insumos';
import { ISelectableOption, MessageBar, MessageBarType, PrimaryButton, Spinner } from '@fluentui/react';
import { AgrupadorCorporacionLiquidadora } from '../../../../../system/agrupador_corporacion_liquidadora/AgrupadorCorporacionLiquidadoraSystem';
import { t } from 'i18next';

interface IReportingSettlementPreliquidation {
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  changeBlockUI: (state: boolean) => void;
  user: User;
  items: LiquidacionInsumo[];
  setItems: React.Dispatch<React.SetStateAction<LiquidacionInsumo[]>>;
  from: DateTime;
  setButtonDisability: (can: boolean) => void;
  settlementType: ISelectableOption<AgrupadorCorporacionLiquidadora>;
  getPreliquidacionReport: (showChangeBlockUI: boolean) => Promise<void>;
  loading: boolean;
}

export const SettlementsTable = (props: IReportingSettlementPreliquidation) => {
  return (
    <div>
      <div className="padding-1 ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <StatusFilms redText="Insumo no cargado / cargado con observaciones" />
        </div>

        {props.loading ? (
          <Spinner label={t('Obteniendo insumos para validar...')} className="mb-2" />
        ) : props.items.length === 0 ? (
          <MessageBar className="mt-2 mb-2" messageBarType={MessageBarType.warning}>
            {t('No hay insumos disponibles')}
          </MessageBar>
        ) : (
          <>
            <PrimaryButton onClick={() => props.getPreliquidacionReport(false)}>{t('Revalidar insumo')}</PrimaryButton>
            <LevelsTable
              items={props.items}
              setItems={props.setItems}
              periodo={props.from}
              system={props.system}
              changeBlockUI={props.changeBlockUI}
              setButtonDisability={props.setButtonDisability}
              settlementType={props.settlementType}
            />
          </>
        )}
      </div>
    </div>
  );
};
